import request from '@/utils/request'

export function getEntOrgUserListByPage(data,log) {
  return request({
    url: `/camds/entorguser/page`,
    params: data,
    log,
    method: 'get'
  })
}

export function getEntOrgUserForView(data,log) {
  return request({
    url: `/camds/entorguser/fingEntOrgUser/`+data,
    log,
    method: 'get'
  })
}

export function getEntOrgUserForEdit(data,log) {
  return request({
    url: `/camds/entorguser/getRoleViewgetEntOrgUserForEdit/`+data,
    log,
    method: 'get'
  })
}

export function getRoleViewById(data,log) {
  return request({
    url: `/camds/entorguser/getRoleViewById/`+data,
    log,
    method: 'get'
  })
}

export function findUserRole(log) {
  return request({
    url: `/camds/entorguser/findUserRole`,
    log,
    method: 'get'
  })
}

//新增企业用户
export function goCreateSave(data,  log) {
  return request({
    url: '/camds/entorguser/goCreateSave',
    method: 'post',
    data,
    log
  })
}

//修改企业用户
export function goUpdateSave(data,  log) {
  return request({
    url: '/camds/entorguser/goUpdateSave',
    method: 'post',
    data,
    log
  })
}

//取得该企业下所有用户状态
export function buserStatus(params, log) {
  return request({
    url: '/camds/entorguser/buserStatus',
    method: 'get',
    params,
    log
  })
}

//企业/部门列表查询
export function getEnterpriseViewList(data, log) {
  return request({
    url: '/camds/entorguser/getEnterpriseViewList',
    method: 'post',
    data,
    log
  })
}

//根据ID查询企业信息详情
export function findEnterpreseInfoViewByOrgId(orgId, log) {
  return request({
    url: `/camds/entorguser/findEnterpreseInfoViewByOrgId/${orgId}`,
    method: 'get',
    log
  })
}

//根据用户ID查询用户上传下载权限
export function findEntOrgUserAndUpDnLoad(userId, log) {
  return request({
    url: `/camds/entorguser/findEntOrgUserAndUpDnLoad/${userId}`,
    method: 'get',
    log
  })
}

//根据用户ID查询用户离线权限
export function findCos(loginEnpId, log) {
  return request({
    url: `/camds/entorguser/findCos/${loginEnpId}`,
    method: 'get',
    log
  })
}

//保存用户离线授权信息
export function updateUserCos(data, log) {
  return request({
    url: `/camds/entorguser/updateUserCos`,
    method: 'post',
    data,
    log
  })
}

//保存用户上传下载授权信息
export function updateUserUPDownLoad(data, log) {
  return request({
    url: `/camds/entorguser/updateUserUPDownLoad`,
    method: 'post',
    data,
    log
  })
}

//本企业供应商联系人找
export function findSupplierEnterperseListView(data, log) {
  return request({
    url: `common/supplierContact/findSupplierEnterperseListView`,
    method: 'post',
    data,
    log
  })
}
